// extracted by mini-css-extract-plugin
module.exports = {"titleBar":"CustomDialogTitleBar_titleBar__3ebRt","title":"CustomDialogTitleBar_title__3CCI9","actions":"CustomDialogTitleBar_actions__2YKGJ"};